import { useUserData } from "../UserContext"
import AccessManager from "./AccessManager"

export default _ => {
    const [user] = useUserData();
    const hasAcces = (object, action, ressource) => AccessManager(user, object, action, ressource);

    return hasAcces;
}